import { status } from "./status";

export const module = {
    namespaced: true,
    modules: {
        status
    }
};



// WEBPACK FOOTER //
// ./src/store/module/module.js